const Menu = [
  {
    id: 1,
    image: "images/maggi.jpg",
    name: "maggi",
    category: "breakfast",
    price: "12₹",
    title: "2-Minute Jadoo",
    description:
"Never Ended Varity Of Maggi. Perfect for chai-time gossip....."
  },
  {
    id: 2,
    image: "images/allupakoida.jpg",
    name: "allu pakoida",
    category: "evening",
    price: "20₹",
    title: "Pakoda Punch",
    description:
      "Crispy aloo fritters with chutney swag. Perfect for chai-time gossip.",
  },
  {
    id: 3,
    image: "images/corn.jpg",
    name: "corn",
    category: "breakfast",
    price: "10₹",
    title: "Makkai Madness",
    description:
      "Sweet corn with masala twist—light snack with heavy attitude.",
  },
  {
    id: 4,
    image: "../images/chola.jpg",
    name: "chola",
    category: "lunch",
    price: "50₹",
    title: "Chole Chaupal",
    description:
      "Spicy chickpeas that slap harder than Monday blues. Pair with bhature or rice.",
  },
  {
    id: 5,
    image: "../images/pizza.jpg",
    name: "pizza",
    category: "evening",
    price: "80₹",
    title: "Desi Italiano",
    description:
      "Cheesy, saucy, and totally over the top. Pizza with a desi twist.",
  },
 
  {
    id: 7,
    image: "../images/sweet.jpg",
    name: "Sweets",
    category: "dinner",
    price: "60₹",
    title: "Meetha Magic",
    description:
      "Gulab jamun, rasgulla, and more—sweet dreams are made of this.",
  },
  {
    id: 8,
    image: "../images/rajmarice.jpg",
    name: "Rajma Rice",
    category: "lunch",
    price: "60₹",
    title: "Rajma Rumble",
    description:
      "Red beans in spicy gravy over rice—comfort food with swag.",
  },
  {
    id: 9,
    image: "../images/samosa.jpg",
    name: "samosa",
    category: "evening",
    price: "10₹",
    title: "Badnaam Golgappa",
    description:
      "Triangular troublemaker stuffed with masala. Samosa never disappoints.",
  },

  // New Dishes Start Here
  {
    id: 10,
    image: "../images/idli.jpg",
    name: "Idli",
    category: "breakfast",
    price: "20₹",
    title: "Thanda Bomb",
    description: "Soft, white, and explodes with sambhar swag.",
  },
  {
    id: 11,
    image: "../images/upma.jpg",
    name: "Upma",
    category: "breakfast",
    price: "18₹",
    title: "Sookha Swag",
    description: "Dry but deadly. Upma silently wins hearts.",
  },
  {
    id: 12,
    image: "../images/methi.jpg",
    name: "Methi Thepla",
    category: "breakfast",
    price: "25₹",
    title: "Thepla Tapori",
    description: "Gujarati breakfast with methi punch and attitude.",
  },
  {
    id: 13,
    image: "../images/kadhi.jpg",
    name: "Kadhi Chawal",
    category: "lunch",
    price: "50₹",
    title: "Khatta King",
    description: "Tangy kadhi meets soft rice—combo that slaps.",
  },
  {
    id: 14,
    image: "../images/baigan.jpg",
    name: "Baingan Bharta",
    category: "lunch",
    price: "45₹",
    title: "Bharta Blast",
    description: "Smoky, spicy, and surprisingly sexy.",
  },
  {
    id: 15,
    image: "../images/mixveg.jpg",
    name: "Mix Veg",
    category: "lunch",
    price: "60₹",
    title: "Sabzi Sabha",
    description: "All veggies united for one cause—taste.",
  },
  {
    id: 16,
    image: "../images/palakpaneer.jpg",
    name: "Palak Paneer",
    category: "lunch",
    price: "80₹",
    title: "Green Scene",
    description: "Spinach meets paneer in a creamy love story.",
  },
  {
    id: 17,
    image: "../images/jeerarice.jpg",
    name: "Jeera Rice",
    category: "lunch",
    price: "40₹",
    title: "Jeera Jalwa",
    description: "Simple, fragrant, and always in demand.",
  },
  {
    id: 18,
    image: "../images/dabeli.jpg",
    name: "Dabeli",
    category: "evening",
    price: "25₹",
    title: "Masala Masti",
    description: "Spicy potato filling with crunch and chutney.",
  },
  {
    id: 19,
    image: "../images/kachori.jpg",
    name: "Kachori",
    category: "evening",
    price: "20₹",
    title: "Kachori Kand",
    description: "Crispy outside, spicy inside—pure drama.",
  },
  {
    id: 20,
    image: "../images/batatawada.jpg",
    name: "Batata Vada",
    category: "evening",
    price: "15₹",
    title: "Vada Vibe",
    description: "Potato bomb wrapped in besan armor.",
  },
  {
    id: 21,
    image: "../images/pavbhaji.jpg",
    name: "Pav Bhaji",
    category: "evening",
    price: "60₹",
    title: "Bhaji Bhau",
    description: "Mashed veggies with butter overload.",
  },
  {
    id: 22,
    image: "../images/vegthali.jpg",
    name: "Veg Thali",
    category: "dinner",
    price: "120₹",
    title: "Thali Takkar",
    description: "Full plate, full power. Boss-level dinner.",
  },
  {
    id: 23,
    image: "../images/malai.jpg",
    name: "Malai Kofta",
    category: "dinner",
    price: "100₹",
    title: "Kofta Kalesh",
    description: "Creamy gravy with soft koftas—royal riot.",
  },
  {
    id: 24,
    image: "../images/vegmanchurian.jpg",
    name: "Veg Manchurian",
    category: "dinner",
    price: "90₹",
    title: "Manchurian Mela",
    description: "Desi Chinese with full jhakaas taste.",
  },
];

export default Menu;
